<template>
  <div class="optionWrapper">
    <div class="category" @click="toggleOption()">
      <p>{{ categoryName }}</p>
      <img
        class="arrow"
        :class="{ arrowExpanded: expanded }"
        src="https://iqh-zt-pord-cdn.iqihang.com/common/img/icon-arrow-reverse.png"
        alt="expand"
      />
    </div>
    <div
      class="options"
      :class="{ optionsExpanded: expanded }"
      v-for="item in categoryChildrend"
      :key="item.problemId"
      v-on:click="onTapOption(item.id)"
    >
      <p>{{ item.questionTitle }}</p>
    </div>
  </div>
</template>

<script>
import { getHelpTitleList } from '@/api/personal/helpCenter/index';

export default {
  props: ['singleOption'],
  data() {
    return {
      expanded: false,
      categoryName: '',
      categoryChildrend: [],
    };
  },

  created() {
    const { id, name } = this.singleOption;
    this.categoryName = name;
    this.getTitleList(id);
  },

  methods: {
    toggleOption() {
      this.expanded = !this.expanded;
    },

    onTapOption(id) {
      this.$router.push({
        path: '/guidiance',
        query: {
          guidianceId: id,
        },
      });
    },

    async getTitleList(id) {
      const result = await getHelpTitleList(id); // title接口
      if (result && result.data) {
        this.categoryChildrend = result.data.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.optionWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  .category {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 70px;
    border-bottom: 1px solid #f5f5f5;
  }

  .category > p {
    color: #333;
    font-weight: 400;
    font-size: 29px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  }

  .category > img {
    width: 43px;
    height: 43px;
    object-fit: cover;
    transition: all 300ms ease-out;
  }

  .options {
    // display: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 96%;
    height: 0;
    overflow: hidden;
    transition: all 300ms ease-out;
  }

  .options > p {
    color: #333;
    font-weight: 400;
    font-size: 29px;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
  }
}

.arrowExpanded {
  transform: rotate(180deg);
}

.optionsExpanded {
  // display: flex !important;
  height: 70px !important;
  border-bottom: 1px solid #f5f5f5;
}
</style>
